import { Component, Input, OnInit, inject } from '@angular/core';
import { NavItem } from '@shared/components/navigation/model/nav-item.model';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelActionRow } from '@angular/material/expansion';
import { MatMenuItem } from '@angular/material/menu';
import { AuthService } from '@src/app/features/authentication/services/auth.service';

@Component({
  selector: 'stx-mobile-button-with-subitems',
  templateUrl: './mobile-button-with-subitems.component.html',
  styleUrls: ['./mobile-button-with-subitems.component.scss'],
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelActionRow, MatMenuItem, RouterLink, TranslateModule]
})
export class MobileButtonWithSubitemsComponent implements OnInit {
  @Input() buttonWithSubItems: NavItem;

  private authService = inject(AuthService);

  filteredSubItems: NavItem[] = [];

  ngOnInit(): void {
    this.filteredSubItems =
      this.buttonWithSubItems.subItems?.filter(item => {
        if (item.permission) {
          return this.authService.checkUserPermission(item.permission);
        }
        return true;
      }) || [];
  }
}
